import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AccountGroup } from '@vendasta/account-group';
import { Order } from '@vendasta/sales-orders';
import { format } from 'date-fns';

export interface CreateOrderDialogData {
  business: AccountGroup;
  order: Order;
}

export type CreateOrderDialogOutput = 'new-order' | 'latest-order' | 'cancel';

@Component({
  selector: 'orders-create-order-dialog',
  templateUrl: './create-order-dialog.component.html',
  styleUrls: ['./create-order-dialog.component.scss'],
  standalone: false,
})
export class CreateOrderDialogComponent {
  data: CreateOrderDialogData;
  contractStartDate = this.formatContractDate(new Date());

  constructor(
    private readonly dialogRef: MatDialogRef<CreateOrderDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: CreateOrderDialogData,
  ) {
    this.data = data;
    if (data?.order?.requestedActivation) {
      this.contractStartDate = this.formatContractDate(data.order.requestedActivation);
    }
  }

  createNewOrder(): void {
    this.dialogRef.close('new-order');
  }

  goToDraftOrder(): void {
    this.dialogRef.close('latest-order');
  }

  close(): void {
    this.dialogRef.close('cancel');
  }

  private formatContractDate(date: Date): string {
    return format(date, 'MMMM d, yyyy');
  }
}
